import React, { ReactElement } from 'react';

import CrossReferenceBannerSectionCampaignContent from 'components/CrossReferenceBannerSectionCampaignContent/CrossReferenceBannerSectionCampaignContent';
import FullWidthCampaignContent from 'components/FullWidthCampaignContent/FullWidthCampaignContent';
import GalleryTileCampaignContent from 'components/GalleryTileCampaignContent/GalleryTileCampaignContent';
import HorizontalLeftImageCampaignContent from 'components/HorizontalLeftImageCampaignContent/HorizontalLeftImageCampaignContent';
import HorizontalRightImageCampaignContent from 'components/HorizontalRightImageCampaignContent/HorizontalRightImageCampaignContent';
import StatisticTileCampaignContent from 'components/StatisticTileCampaignContent/StatisticTileCampaignContent';
import VerticalTileCampaignContent from 'components/VerticalTileCampaignContent/VerticalTileCampaignContent';
import { ICampaignContent } from 'models/campaignContent';
import Layouts from 'models/layouts';

export default function getCampaignContentComponent(
  layout: Layouts | undefined,
  campaignContent: ICampaignContent,
  colour: string,
): ReactElement<any, any> | null {
  switch (layout) {
    case Layouts.VERTICAL_TILE:
      return (
        <VerticalTileCampaignContent
          campaignContent={campaignContent}
          colour={colour}
        />
      );
    case Layouts.FULL_WIDTH:
      return (
        <FullWidthCampaignContent
          campaignContent={campaignContent}
          colour={colour}
        />
      );
    case Layouts.HORIZONTAL_LEFT_IMAGE:
      return (
        <HorizontalLeftImageCampaignContent
          campaignContent={campaignContent}
          colour={colour}
        />
      );
    case Layouts.HORIZONTAL_RIGHT_IMAGE:
      return (
        <HorizontalRightImageCampaignContent
          campaignContent={campaignContent}
          colour={colour}
        />
      );
    case Layouts.GALLERY_TILE:
      return (
        <GalleryTileCampaignContent
          campaignContent={campaignContent}
          colour={colour}
        />
      );
    case Layouts.STATISTIC_TILE:
      return (
        <StatisticTileCampaignContent
          campaignContent={campaignContent}
          colour={colour}
        />
      );
    case Layouts.CROSS_REFERENCE_BANNER:
      return (
        <div
          style={{
            width: 'auto',
            margin: '0 calc(((100vw - 100%) / 2) * -1)',
          }}
        >
          <CrossReferenceBannerSectionCampaignContent
            campaignContent={campaignContent}
          />
        </div>
      );
    default:
      return null;
  }
}
